// ABOUTME: Utility functions for formatting values displayed in the UI.
// ABOUTME: Contains time/duration formatters used across multiple components.

/**
 * Formats a duration in minutes to a human-readable format.
 * - Whole hours: "2ó"
 * - Half hours (divisible by 30): "2.5ó"
 * - Under 60 minutes: "40p"
 * - Other cases: "2ó 10p"
 *
 * @param {number} minutes - Duration in minutes
 * @returns {string} Formatted duration string
 */
export function formatHorizon(minutes, { hourUnit = 'ó', minuteUnit = 'p' } = {}) {
  if (minutes == null) return '-';

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  // Under 1 hour - just show minutes
  if (hours === 0) {
    return `${minutes}${minuteUnit}`;
  }

  // Exactly whole hours
  if (remainingMinutes === 0) {
    return `${hours}${hourUnit}`;
  }

  // Half hours (30 minutes remaining)
  if (remainingMinutes === 30) {
    return `${hours}.5${hourUnit}`;
  }

  // Other cases: show hours and minutes
  return `${hours}${hourUnit} ${remainingMinutes}${minuteUnit}`;
}

/**
 * Formats an ISO datetime string as HH:mm in Hungarian locale.
 *
 * @param {string} isoString - ISO 8601 datetime string
 * @returns {string} Formatted time string or '-' if invalid/null
 */
export function formatTime(isoString) {
  if (!isoString) return '-';
  try {
    const date = new Date(isoString);
    return date.toLocaleTimeString('hu-HU', { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '-';
  }
}
